<div class="asepticModalHead modal-header border-0 text-center justify-content-between modal-header-box align-items-center">
    <div class="modal-title w-100 sticky d-flex justify-content-between align-items-center">
        <div class="">
            <h2 class="page-title">{{ institutionData? institutionData.institution.institution.institutionName: ""}}</h2>
        </div>
    </div>
    <div class="">
        <button class="btn-cancel-bordered-bd" (click)="onClickClose();">
            {{ translationKeys.InstitutionManagement.Close | translate}}</button>
    </div>
</div>


<div class="wards-container">
    <div class="">
        <h2 class="institution-title">
            {{ 'WEBKESS_INTEGRATION.WARDS' | translate }}
        </h2>
    </div>
            
    <div class="wards-table">
        <table class="importTable" *ngIf="gridData.webkessWards && gridData.webkessWards.length > 0">
            <thead class="importThead">
                <tr >
                    <th><span>{{ 'WEBKESS_INTEGRATION.WEBKESS_WARD' | translate }}</span></th>
                    <th><span>{{'WEBKESS_INTEGRATION.ACTION' | translate}}</span></th>
                    <th><span>{{'WEBKESS_INTEGRATION.SELECT_OPTION' | translate}}</span></th>
                </tr>
            </thead>
            <tbody class="importTbody">
                <tr *ngFor="let webkessWard of gridData.webkessWards,  let i = index;">
                    <td>{{webkessWard.oeName}}</td>
                    <td>
                        <select class="actionSelect" (change)="onActionChange($event, i)">
                            <option *ngFor="let action of importActions, let j = index" [value]="action.actionId">{{action.actionName | translate}}</option>
                        </select>
                    </td>
                    <td> 
                        <span *ngIf="webkessWard.actionId == 0 || !webkessWard.actionId"></span>
                        <select class="deptSelect" *ngIf="webkessWard.actionId == 1" (change)="onDeptChange($event, i)">
                            <option *ngFor="let department of gridData.departments, let d = index" value="{{department.departmentID}}">{{department.departmentName}}</option>
                        </select>
                        <select class="ml-2 deptTypeSelect" *ngIf="webkessWard.actionId == 1" (change)="onDepartmentTypeIDChange($event, i)">
                            <option *ngFor="let deptType of gridData.departmentTypes, let dt = index" value="{{deptType.departmentTypeID}}">{{deptType.departmentTypeName | translate}}</option>
                        </select>
                        <select class="wardSelect" *ngIf="webkessWard.actionId == 2" (change)="onWardChange($event, i)">
                            <option *ngFor="let ward of gridData.wards, let w = index" value="{{ward.wardID}}">{{ward.wardName}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="footer d-flex align-items-center justify-content-end">
    <button class="btn-bd" (click)="onSubmit($event)">
        {{'AUTHORIZATION.SUBMIT' | translate}}
    </button>
</div>

<ng-template #matchDuplicated>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate}}</h5>
        <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p class="lead">
            The matchmaking has duplicated values of v2 migrated wards.
        </p>
        <p class="lead font-weight-bold">
            Please, check it and submit
        </p>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-center align-items-center d-flex">
                    <button (click)="matchRef.hide();" class="btn btn-primary">{{translationKeys.Button.Ok |
                        translate}}</button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
